document.addEventListener('rebuy:cart.ready', (event) => { 
    document.addEventListener('rebuy:cart.change', (event) => { 
        
        const bubbles = document.querySelectorAll(".cart-link__bubble");
        const cartCount = event.detail.cart.cart.item_count;

        let totalCount = cartCount;

        if (event.detail.item && typeof event.detail.item.quantity === 'number') {
        const itemCount = event.detail.item.quantity;
        totalCount = itemCount > 0 ? cartCount + itemCount : cartCount;
        }

        if (bubbles.length) {
            if (totalCount > 0) {
                bubbles.forEach((b) => {
                b.classList.add("cart-link__bubble--visible");
                });
            } else {
                bubbles.forEach((b) => {
                b.classList.remove("cart-link__bubble--visible");
                });
            }
        }
    })
});